import { Printer } from './../../masterdata/models/printer';
import { CovidSamples, DilutedCovidSamples } from './../../agptesting-newview/model/covid-sample';
import { UnboxedSample } from './unboxing-sample';
import { MergedBatch } from './merged-batch';
import { Comment } from './comment';
import { ChannelTestingTypeMapping } from './channel-testing-type-mapping';
import { ParentBatchWithMergedBatch } from './parent-batch-with-merged-batch';
import { Step } from '../../models/step';

export class Covid19Batch {
    _id: string;
    version: number;
    userID: string;
    creationDate: Date;
    lab: string;
    labName: string;
    batchID: string;
    aliquotPlateID: string;
    normalizationPlateID: string;
    cleanUpPlateID: string;
    processSteps: Step[];
    sender: string;
    count: number;
    puidUnboxing: string;
    receptionDateTime: Date;
    samplingDateTime: Date;
    puidController1: string;
    puidController2: string;
    completenessCheckDateTime: Date;
    rnaPlateID: string;
    machineName: string;
    puidExtraction: string;
    puidStartExtraction: string;
    puidStartExtractor: string;
    startExtraction: Date;
    startExtractorDateTime: Date;
    samples: CovidSamples[];
    dilutedSamples: DilutedCovidSamples[];
    completionDateTimeExtraction: Date;
    pcrPlateID: string;
    machineName1: string;
    puidPCR1: string;
    puidPCR2: string;
    startDatePCR: Date;
    completionDateTimePCR: Date;
    splitBatchDateTime:Date;
    puidSplitBatch:string;
    kitLot: string;
    cpValuePCRPC: string;
    qcRangeCpValue: string;
    puidEvaluation: string;
    completionDateTimeEvaluation: Date;
    resultFileNames: string;
    resultDispatchedyPUID: string;
    resultSentDateTime: Date;
    positiveResultCount: number;
    comment: string;
    statusOfTheBatch: string;
    previousStatusOfTheBatch: string;
    analysisStartedPUID : string;
    analysisStartedDateTime : Date;
    excelUploadCreatedAt: Date;
    excelUploadCreatedBy: string;
    redoPUID: string;
    redoDateTime: Date;
    ntcOk: boolean;
    ipcOk: boolean;
    extractionKitVendor: string;
    rtPCRKitVendor: string;
    clippingStartDateTime: Date;
    puidClipping: string;
    clippingCompletionDateTime: Date;
    puidCompleteClipping: string;
    lysisStartDateTime: Date;
    puidstartLysis: string;
    lysisCompletionDateTime: Date;
    puidCompleteLysis: string;
    //bach creation
    product:string;
    labelCopies:number;
    rushSample:boolean;
    locked:boolean;
    ncSample: boolean;
    printer:Printer;
    swabType:string;
    unboxedSamples:UnboxedSample[];
    redoUnboxedSamples:UnboxedSample[];
    redoSampleList: string[];
    deleteSampleFromUnboxedList: string[];
    unboxedSamplesForReceived:UnboxedSample[];
    scanCompletePUID: string;
    scanCompleteDateTime: Date;
    unboxedCountOfSampleList: number;
    sampleListSizeWithoutControls: number;
    deliveryReceivedDateTime: Date;
    sampleOrigin: string;
    wellType: WellType;
    sourceBatchIds:string[]=[];
    precyclingStartDateTime: Date;
    puidstartPrecycling: string;
    precyclingCompletionDateTime: Date;
    puidCompletePrecycling: string;
    mergedBatches: MergedBatch[];
    samplesMap: any;
    systemResult: boolean;
    finalResult: string;
    resultUploaded: boolean;
    registeredUnboxedSamples:any;
    workFlowName: string;
    scannedBarcodes: string[] = [];
    scannedControls: CovidSamples[] = [];
    chemicalInfoWithLotNos:any;
    chemicalInfoWithCpValues:any;
    redoCount: number;
    redoStatus: string;
    username: string;
    password: any[]=[];
    eventForAuthorization: boolean;

    comments: Comment[] = [];
    ixoUploaded: boolean;
    mergeGroup: string;

    puidUndoMerge: string;
    undoMergeDateTime: Date;

    redoReason: string;
    redoStep: string;
    negativeCount: number;
    invalidCount: number;
    failedICRCount: number;

    analysisVerificationDateTime: Date;
    analysisVerificationPUID: string;
    externalUploadDateTime: Date;
    externalUploadPUID: string;
    readmeFileComment: string;
    cyclerManufacturer: string;
    quadrant: string;

    channelTestingTypeMapping: ChannelTestingTypeMapping[] = [];
    csvFiles: Set<string>;
    filesPerManufacturer: FilesPerManufacturer[];
    history: BatchHistory[];

    batchIDFor96Plates: string[];
    batchIDFor384Plates: ParentBatchWithMergedBatch[];
    excludeFromArchiveSearch : boolean;
    archiveBatchSources: string[];
    archiveProcessedPUID: string;
    archiveProcessedDateTime: Date;
    batchUploadedPUID: string;
    batchReceivedPUID: string;
    plateTransferredPUID: string;
    startArticPoolingPUID: string;
    completeArticPoolingPUID: string;
    startPurification1PUID: string;
    completePurification1PUID: string;
    startPurification3PUID: string;
    completePurification3PUID: string;
    controlsAddedPUID: string;
    startArticQCPUID: string;
    completeArticQCPUID: string;
    startEndRepairPUID: string;
    completeEndRepairPUID: string;
    startLibQCPUID: string;
    completeLibQCPUID: string;
    startcDNAPUID: string;
    completecDNAPUID: string;
    startAdapterLigationPUID: string;
    completeAdapterLigationPUID: string;
    startArticPCRPUID: string;
    completeArticPCRPUID: string;
    startNormalizationPUID: string;
    completeNormalizationPUID: string;
    startPurification2PUID: string;
    completePurification2PUID: string;
    startLibPoolingPUID: string;
    completeLibPoolingPUID: string;
    startTagPCRPUID: string;
    completeTagPCRPUID: string;
    transferSequencingPUID: string;
    completedSequencingPUID: string;


    batchUploadedDateTime: Date;
    batchReceivedDateTime: Date;
    plateTransferredDateTime: Date;
    startArticPoolingDateTime: Date;
    completeArticPoolingDateTime: Date;
    startPurification1DateTIme: Date;
    completePurification1DateTIme: Date;
    startPurification3DateTIme: Date;
    completePurification3DateTIme: Date;
    controlsAddedDateTime: Date;
    startArticQCDateTime: Date;
    completeArticQCDateTime: Date;
    startEndRepairDateTime: Date;
    completeEndRepairDateTime: Date;
    startLibQCDateTime: Date;
    completeLibQCDateTime: Date;
    startcDNADateTime: Date;
    completecDNADateTime: Date;
    startAdapterLigationDateTime: Date;
    completeAdapterLigationDateTime: Date;
    startArticPCRDateTime: Date;
    completeArticPCRDateTime: Date;
    startNormalizationDateTime: Date;
    completeNormalizationDateTime: Date;
    startPurification2DateTIme: Date;
    completePurification2DateTIme: Date;
    startLibPoolingDateTime: Date;
    completeLibPoolingDateTime: Date;
    startTagPCRDateTime: Date;
    completeTagPCRDateTime: Date;
    transferSequencingDateTime: Date;
    completedSequencingDateTime: Date;
    sampleUploadedFileName: string;
    tagPlateId: string;
    measuredArticQCDateTime: Date;
    measuredArticQCPUID: string;
    measuredLibQCDateTime: Date;
    measuredLibQCPUID: string;
    articQCResultUploaded: boolean;
    libQCResultUploaded: boolean;
    measuredSampleQCPUID:string;
    measuredSampleQCDateTime:Date;
    sampleQCResultUploaded:boolean;
    assignTagPlateDateTime: Date;
	assignTagPlatePUID: string;
    tagPlateBarcode: string;
    coProjectId: string;
    externalIdentification: string;
    country:string;
	regionalCode:string;
	organizationName:string;
	contactName:string;
	contactEmail:string;
	contactPhoneNumber:string;
	numberOfPlatesPerShipment:string;
	numberOfSamplesPerPlate:string;
    plateBarcode:string;
    filterDateTime: Date;
    runAndLaneIdInfo: RunLane[];
    startPrimaryAnalysisDateTime: Date;
	completePrimaryAnalysisDateTime: Date;
	startSecondaryAnalysisDateTime: Date;
	completeSecondaryAnalysisDateTime: Date;
	startDataReviewDateTime: Date;
	readyForDeliveryDateTime: Date;
    startDeliveryDateTime: Date;
    deliveryCompletionDateTime: Date;
    invoicedDateTime: Date;
    startFinalQCDateTime: Date;
    completeFinalQCDateTime: Date;
    startArticPurificationDateTime: Date;
    completeArticPurificationDateTime: Date;
    startPrimaryAnalysisPUID: string;
	completePrimaryAnalysisPUID: string;
	startSecondaryAnalysisPUID: string;
	completeSecondaryAnalysisPUID: string;
	startDataReviewPUID: string;
	readyForDeliveryPUID: string;
    startDeliveryPUID: string;
    deliveryCompletionPUID: string;
    invoicedPUID: string;
    startFinalQCPUID: string;
    completeFinalQCPUID: string;
    startArticPurificationPUID: string;
    completeArticPurificationPUID: string;
    matchedBatchCount:number;
    matchedBatchIDs:string;
    customerUploadPUID: string;
    nglimsProjectId: string;
    nglimsSampleId: string;
    primaryAnalysisImportedDateTime: Date;
    requiredRead: number;
    orderReceptionComment: string;
    requiredReadFormat: string;
    libraryId: string;
    deliveryTargetDateTime: Date;
    plannedTagPlate: string;
    undeterminedReads: number;
    mutationInformationImportedDateTime: Date;
    resultsImported: boolean;
    metricsResultsImportedDateTime: Date;
    secondaryAnalysisHtmlPath: string;
    senderName:any[];
    channelwithCutoffValue:ChannelwithCutoffValue[];
    externalUpload:boolean;
    qcFailedForMetricMerged: QCFailedForMetricMergedMapper;
    pangolianTextFilePath: string;
    pangolianResultsImportedDateTime: Date;

    currentRedoBatch:string;
    articQCFailed: boolean;
    libQCFailed: boolean;
    finalQCFailed: boolean;
    dataReviewFailed: boolean;
    redoLibQCPUID: string;
    redoLibQCDateTime: Date;
    redoFinalQCPUID: string;
    redoFinalQCDateTime: Date;
    redoDataReviewQCPUID: string;
    redoDataReviewQCDateTime: Date;
    sourceBatchIdMap: any;
    statusOfTheBatch96: string;
    statusOfTheBatch384: string;
    workFlow:string;
    createdFromAnalysis: string;
    superRush: boolean;
    redoChannel: string;
    workflowGroup: string;
    processBatchCount:number;
    processBatch:boolean;
    cDNAWorkfileDateTime:Date;
    cDNAWorkfilePUID:string;

    mergeDefinedPUID:string;
    mergeDefinedDateTime:Date;
    mergeCompletePUID:string;
    mergeCompleteDateTime:Date;
    startPcrPUID:string;
    startPcrDateTime:Date;
    completePcrPUID:string;
    completePcrDateTime:Date;
    startPoolingPUID:string;
    startPoolingDateTime:Date;
    completePoolingPUID:string;
    completePoolingDateTime:Date;
    startPurificationPUID:string;
    startPurificationDateTime:Date;
    completePurificationPUID:string;
    completePurificationDateTime:Date;
    startSequencingDateTime: Date;
    startSequencingPUID: string;
    sampleUpdate: any;
    lastUsedTagPlateId: string;
    tagSystemName: string;
    mergeBatchHistory:string[]=[];
    snpResultUploadDateTime: Date;
    snpResultUploadPUID: string;
    tagSortingFileDateTime: Date;
	tagSortingFilePUID: string;
    midplexTagSortingFileName:string;
    midplexMergedSamples: any;
    batchRenameEarly:boolean;
    shuffledoriginalBatchID:string;
    nglimsSampleCreationDateTime:Date;
    nglimsSampleCreationPUID:string;
    countedForInvoice:boolean;
    startSampleQCDateTime: Date;
    startSampleQCPUID: string;
    completeSampleQCDateTime: Date;
    completeSampleQCPUID: string;
    startArticTagmentationDateTime: Date;
    startArticTagmentationPUID: string;
    completeArticTagmentationDateTime: Date;
    completeArticTagmentationPUID: string;
    completeCleanUpPUID: string;
    startCleanUpDateTime: Date;
    startCleanUpPUID: string;
    completeCleanUpDateTime: Date;
    archiveData: any[];
    libQcMachine:string;
    libQcMachineType:string;
    lowMolarity:boolean;
}


export enum WellType {
    WELL96="WELL96",
    WELL384="WELL384"
}

export class FilesPerManufacturer{
    fileName: string;
    fileType: string;
}

export class BatchHistory{
    currentBatch: string;
    originalBatch: string;
}

export class RunLane{
    runId: string;
	laneId: string;
	runSequencingDateTime: Date;
	runSequencingStartedBy: string;
}
export class ChannelwithCutoffValue{
    channelSearched: string;
    cuttoffValue: string;

}

export class QCFailedForMetricMergedMapper{
    qcFailedForBatch: boolean;
    qcBatchLastEvaluatedResult: Date;
}
